import React, { useContext, useEffect, useState } from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
import PriceTable from '../components/PriceTable';


const Home = () => {

  useEffect(() => {
    const analytics = getAnalytics();
    logEvent(analytics, 'page_view', {
      page_name: 'home',
    });
  }, []);

  return (
    <>
      <div className="p-10 flex flex-col gap-2">
        <PriceTable />
      </div>
    </>
  );
};

export default Home;
